import React, { useEffect } from 'react';
import SelectField from './SelectField';
import { classNamesPrefixed } from '../../../helpers/CoreHelpers';

const unitOptions = Array(10).fill(0).map((_, i) => ({
  id: i + 1,
  title: `${i + 1}`
}))

const DEFAULT_VALUE = Object.freeze({
  units: 1
});

const Unit = (props) => {
  const { input } = props;

  useEffect(() => {
    if (typeof input.value === 'string') {
      input.onChange({ ...DEFAULT_VALUE })
    }
  }, []);

  const handleSelectChange = (value) => {
    input.onChange({
      ...input.value,
      units: value
    });
  };

  const label = (
    <span>
      <b>Units</b>
      <span
        className={classNamesPrefixed({ "info__label": true })}
        data-tip={`
          <div>
            <p><b>Units</b> define the spacing between blocks.</p>
            <p>1 unit = 4px or 0.25 rem.</p>
          </div>
        `}
        data-for="help-text-tooltip"
      />
    </span>
  );

  return (
    <div>
      <SelectField
        label={label}
        placeholder="Select a unit"
        items={unitOptions}
        input={{ value: input.value.units }}
        afterOnChange={handleSelectChange}
        omitCollapsible={true}
      />
    </div>
  );
};

export default Unit;


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/Unit.js